import React, { useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";
import { Box, CircularProgress, Typography } from "@mui/material";
import UnlockedIcon from "../../../assets/icons/UnlockedIcon";
import LockedPlusIcon from "../../../assets/icons/LockPlusIcon";
import InlineIconButton from "../../Buttons/InlineIconButton/InlineIconButton";
import useShotClockTimer from "../../../hooks/useShotClockTimer/useShotClockTimer";
import StyledTooltip from "../../StyledTooltip/StyledTooltip";
import { parseMcleodDateWithOffset } from "../../../utils/dateHelpers";
import { LockedLoadsContext } from "../../Dashboard/Dashboard";

export default function TableShotClock({
  activeUser,
  isLoading,
  load,
  handleLockLoad,
  setAvailableToBook,
  active,
  actionCallback
}) {
  const [toolTipTitle, setToolTipTitle] = useState("");
  const [expirationTime, setExpirationTime] = useState("");
  const [loadLocked, setLoadLocked] = useState({});
  const lockedLoads = useContext(LockedLoadsContext);
  const { timeRemaining } = useShotClockTimer(loadLocked, expirationTime);

  useEffect(() => {
    const userLock = loadLocked?.lockedUserId === activeUser?.userIdMcld;

    if (loadLocked) {
      setToolTipTitle("View Queue");
      setAvailableToBook(userLock);
    } else {
      setToolTipTitle("Lock Load");
      setAvailableToBook(true);
    }

    if (loadLocked && loadLocked.unlockTime) {
      setExpirationTime(parseMcleodDateWithOffset(loadLocked.unlockTime));
    } else {
      setExpirationTime("");
    }
  }, [loadLocked]);

  useEffect(() => {
    setLoadLocked(lockedLoads?.find(ll => ll.id == load.movementId));
  }, [lockedLoads, load]);

  return (
    <Box sx={{ display: "flex", alignItems: "center", width: "60px" }}>
      <StyledTooltip title={toolTipTitle}>
        <Box>
          {loadLocked && !isLoading &&
            <InlineIconButton
              onClick={() => actionCallback({ action: "shot-clock-locked", load: load, expirationTime: expirationTime, loadLocked: loadLocked })}
              icon={LockedPlusIcon}
              buttonColor={active ? "white" : "blue"}
            />
          }
          {!loadLocked && !isLoading &&
            <InlineIconButton
              onClick={handleLockLoad}
              icon={UnlockedIcon}
              buttonColor={active ? "white" : "blue"}
            />
          }
          {isLoading &&
            <Box sx={{ display: "flex", alignItem: "center", marginLeft: "4px" }}>
              <CircularProgress sx={{ color: "primary.60" }} size={16} />
            </Box>
          }
        </Box>
      </StyledTooltip>
      {!isLoading &&
        <Typography variant="body1" color={active ? "white_opacity.100" : "black_opacity.80"}>
          {timeRemaining}
        </Typography>
      }
    </Box>
  );
}

TableShotClock.propTypes = {
  activeUser: PropTypes.object,
  isLoading: PropTypes.bool.isRequired,
  load: PropTypes.object,
  handleLockLoad: PropTypes.func.isRequired,
  setAvailableToBook: PropTypes.func.isRequired,
  active: PropTypes.bool,
  actionCallback: PropTypes.func.isRequired
};